<mat-checkbox
  color="primary"
  [ngModel]="getPointVisibilityForSensor()"
  (ngModelChange)="setPointVisibilityForSensor($event)"
>
  {{ label }}
</mat-checkbox>

<span class="dot" [style.backgroundColor]="getRgbStringForSensor()"></span>
